import AbstractComponent from "./abstract-component";

const createTemplate = (className, text, title) => {
  return (
    `<span class="${className}" ${title !== `` ? `title="${title}"` : ``}>${text}</span>`
  );
};

export default class SpanComponent extends AbstractComponent {
  constructor({className = ``, text = ``, title = ``}) {
    super();

    this._className = className;
    this._text = text;
    this._title = title;
  }

  getTemplate() {
    return createTemplate(this._className, this._text, this._title);
  }

  set text(data) {
    this._text = data;
    this.getElement().innerHTML = data;
  }

  get text() {
    return this.getElement().textContent;
  }
}
